class Load {
    constructor(showLoading = true) {
        window.showLoading = showLoading;

        if ($('#loader-modal').length > 0) {
            if (showLoading === false) {
                $('#loader-modal').removeClass('visible');
            } else {
                $('#loader-modal').addClass('visible');
            }

        } else {
            if (showLoading && $(document).find('.block-ui').length === 0) {
                $.blockUI({message: `<div><div class="ball-rotate loader-overlay-active"><div></div></div></div></div>`});
            } else {
                $.unblockUI();
            }
        }

        if (!showLoading && window.activeElement) {
            setTimeout(() => {
                window.activeElement.focus();
            }, 500);
        }
    }
}

export default Load;
